import {
  API_ROUTES,
  type MeasurementImportRequest,
  type MeasurementImportResponse,
  type MeasurementPoint,
  type MeasurementPointWriteRequest,
  type MeasurementSeriesDetailResponse,
  type MeasurementSeriesListResponse,
} from '@oscom/shared';
import { apiGet } from './client';
import { jsonInit, sendAndUnwrap } from './send';

function seriesUrl(customerId: string, seriesId: string): string {
  return `${API_ROUTES.customerMeasurementSeries(customerId)}/${encodeURIComponent(seriesId)}`;
}

export function listMeasurementSeries(customerId: string): Promise<MeasurementSeriesListResponse> {
  return apiGet<MeasurementSeriesListResponse>(API_ROUTES.customerMeasurementSeries(customerId));
}

export function getMeasurementSeries(
  customerId: string,
  seriesId: string,
): Promise<MeasurementSeriesDetailResponse> {
  return apiGet<MeasurementSeriesDetailResponse>(seriesUrl(customerId, seriesId));
}

export async function importMeasurementSeries(
  customerId: string,
  request: MeasurementImportRequest,
): Promise<MeasurementImportResponse> {
  const response = await sendAndUnwrap(
    `${API_ROUTES.customerMeasurementSeries(customerId)}/import`,
    jsonInit('POST', request),
    'Import',
  );
  return (await response.json()) as MeasurementImportResponse;
}

/** The point route has no entry in API_ROUTES (it is not under the series base). */
export async function saveMeasurementPoint(
  customerId: string,
  pointId: string,
  write: MeasurementPointWriteRequest,
): Promise<MeasurementPoint> {
  const response = await sendAndUnwrap(
    `/api/customers/${customerId}/measurement-points/${encodeURIComponent(pointId)}`,
    jsonInit('PUT', write),
    'Speichern',
  );
  return (await response.json()) as MeasurementPoint;
}

export async function deleteMeasurementSeries(customerId: string, seriesId: string): Promise<void> {
  await sendAndUnwrap(seriesUrl(customerId, seriesId), { method: 'DELETE' }, 'Löschen');
}
